import { render, staticRenderFns } from "./IconVocab.vue?vue&type=template&id=0f33dcd6&"
import script from "./IconVocab.vue?vue&type=script&lang=js&"
export * from "./IconVocab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f33dcd6')) {
      api.createRecord('0f33dcd6', component.options)
    } else {
      api.reload('0f33dcd6', component.options)
    }
    module.hot.accept("./IconVocab.vue?vue&type=template&id=0f33dcd6&", function () {
      api.rerender('0f33dcd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconVocab.vue"
export default component.exports